import TemplateWeek, {
  TTemplateWeek,
} from 'modules/shift_management/store/internal/models/TemplateWeek'

class TemplateWeeks {
  templateWeeks: TemplateWeek[]

  constructor(templateWeeks: TemplateWeek[]) {
    this.templateWeeks = templateWeeks
  }

  static buildFromGraphQL(templateWeeks: TTemplateWeek[]): TemplateWeeks {
    const templateWeekObjects = templateWeeks.map((templateWeek) => {
      return TemplateWeek.buildFromGraphQL(templateWeek)
    })

    return new TemplateWeeks(templateWeekObjects)
  }
}

export default TemplateWeeks
